var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336",
    transform: "translate(-1298 -5710)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2531",
    "data-name": "Rectangle 2531",
    transform: "translate(1298 5710)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61,
    height: 45,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_423",
    "data-name": "Line 423",
    x2: 61.913,
    transform: "translate(1299.407 5721.884)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1304 5715)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1309 5715)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1.5,0A1.5,1.5,0,1,1,0,1.5,1.5,1.5,0,0,1,1.5,0Z",
    transform: "translate(1314 5715)",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.7c26263c2f56fba7a9b41fea0df0c5c8.svg";
export { ForwardRef as ReactComponent };